import React, { Component } from 'react';
import { CardActions, CardContent, Grid, Card, Container, CardHeader, Button, Typography } from '@mui/material';
import { planesService } from '../../services/planes.service';
import { bloquesService } from '../../services/bloques.service';
import { userService } from '../../services/user.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default class PlanesPago extends React.Component {
    constructor() {
        super()
        this.state = {
            planes: [],
            bloques: [],
            mensajePendiente: false

        }


    }
    componentDidMount() {
        this.getBloques()
    }
    getBloques() {
        bloquesService.getRegistersOrden().get().then(async (res) => {
            let bloques = []
            res.forEach(item => {
                let bloque = item.data();
                bloque.id = item.id
                bloque.nombresCategorias = '';
                bloque.categorias.forEach(categoria => {
                    bloque.nombresCategorias += categoria.nombre + ', ';
                })

                bloque.nombresCategorias = bloque.nombresCategorias.slice(0, -2);
                bloques.push(bloque);
            })
            let bloquesPlanes = []
            for (let index = 0; index < bloques.length; index++) {
                let item = bloques[index]
                item.planes = await planesService.getPlanesBloquesAsync(item.id)
                bloquesPlanes.push(item)

            }
            this.setState({ bloques });
            this.getUser()

        })
    }

    getUser() {

        userService.getUser(firebase.auth().currentUser.uid).then(res => {
            let usuario = res.data()
            if (usuario.subscripcion == 'pendiente') {
                this.setState({ mensajePendiente: true })
            }
        })
    }


    irAFacturacion = (plan) => () => {
        this.props.navigate('/facturacion/' + plan.id);

    }



    render() {
        return (
            <Container className='pagos' style={{ paddingTop: 30, marginTop: 30}}>
                {this.state.mensajePendiente &&

                 <Alert severity="info">Su plan esta en proceso</Alert>
           
                }

                <div style={{ marginBottom: 40, color: '#000' }}>
                    <h3>ELIJA EL MEJOR PLAN PARA SU NEGOCIO</h3>
                </div>
                {this.state.bloques.map((bloque, indexB) => (
                    <Card key={'B' + indexB} style={{ marginBottom: 10, marginBlockEnd:50  }}>
                        <CardHeader className='pagos1' title= {<Typography style={{fontWeight: 'bold',fontSize: 25 }}>{bloque.nombre}</Typography>} subheader={bloque.nombresCategorias} style={{ textAlign: 'center' }} />
                        <CardContent className='pagos2'>
                            <div className='container-planes-pagos'>
                                {bloque.planes.map((plan, indexP) => (
                                    // <div >
                                        <Card key={'Plan' + indexP} className='plan-pago'>
                                            <CardContent>
                                                <div className='tituloPlanes'>
                                                    {plan.nombre}
                                                </div>

                                                <div className='text-precio1'>
                                                    ${plan.precio}
                                                </div>
                                                <ul style={{height: 250, overflowY: 'auto'}}>
                                                    <li>{`${plan.meses} MESES DE PUBLICIDAD`}</li>
                                                    <li>{`${plan.gratuidad} MES(ES) GRATIS DE PUBLICIDAD - PROMOCIÓN`} </li>
                                                    <li>{`${plan.cantidadProductos} PRODUCTOS A PUBLICAR`}</li>
                                                    {plan.descripcionesAdicionales.map((descripcion, indexD) => (
                                                        <li key={'D' + indexD}> {descripcion}</li>
                                                    ))}
                                                </ul>
                                            </CardContent>
                                            <CardActions >
                                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <Button variant="outlined" color='primary' onClick={this.irAFacturacion(plan)} aria-label='Comprar'>
                                                        <b>Comprar </b>
                                                    </Button>
                                                </div>

                                            </CardActions>
                                        </Card>
                                    // </div>
                                ))}
                            </div>
                            {/* <Grid container spacing={2} justifyContent="center">
                                {bloque.planes.map((plan, indexP) => (
                                    <Grid item xs={12} md={3} key={'P' + indexP}>
                                        <Card>
                                            <CardContent className='pagos3'>
                                                <div className='tituloPlanes'>
                                                    {plan.nombre}
                                                </div>

                                                <div className='text-precio1'>
                                                    ${plan.precio}
                                                </div>
                                                <ul>
                                                    <li>{`${plan.meses} MESES DE PUBLICIDAD`}</li>
                                                    <li>{`${plan.gratuidad} MES(ES) GRATIS DE PUBLICIDAD - PROMOCIÓN`} </li>
                                                    <li>{`${plan.cantidadProductos} PRODUCTOS A PUBLICAR`}</li>
                                                    {plan.descripcionesAdicionales.map((descripcion, indexD) => (
                                                        <li key={'D' + indexD}> {descripcion}</li>
                                                    ))}
                                                </ul>
                                            </CardContent>
                                            <CardActions >
                                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <Button variant="outlined" color='primary' onClick={this.irAFacturacion(plan)} aria-label='Comprar'>
                                                        <b>Comprar </b>
                                                    </Button>
                                                </div>

                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid> */}
                        </CardContent>
                    </Card>
                ))}
            </Container>
        )
    }

}